'use client';

import { useState } from 'react';
import Link from 'next/link';
import { Home, Search, Copy, CheckCircle2 } from 'lucide-react';

export default function NotFound() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const text = [
      `Error: 404 — Page not found`,
      `URL: ${window.location.href}`,
      `Time: ${new Date().toISOString()}`,
    ].join('\n');
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="text-7xl font-extrabold text-card-bg mb-2">404</div>
        <h1 className="text-2xl font-bold text-white mb-3">Page not found</h1>
        <p className="text-fg-muted text-sm leading-relaxed mb-6">
          The page you're looking for doesn't exist or may have been moved. Try searching for a stock or head back to the dashboard.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Link
            href="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-sky-500 hover:bg-sky-600 text-white text-sm font-semibold rounded-lg transition-colors"
          >
            <Home size={14} />
            Dashboard
          </Link>
          <Link
            href="/stocks/screener"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-card-bg hover:bg-card-hover-bg border border-default text-slate-300 text-sm font-medium rounded-lg transition-colors"
          >
            <Search size={14} />
            Stock Screener
          </Link>
        </div>
        <div className="mt-6">
          <button
            onClick={handleCopy}
            className="inline-flex items-center gap-1.5 text-[11px] text-fg-subtle hover:text-fg transition-colors font-mono"
          >
            {copied ? <CheckCircle2 size={12} className="text-emerald-400" /> : <Copy size={12} />}
            {copied ? 'Copied!' : 'Copy error code'}
          </button>
        </div>
      </div>
    </div>
  );
}
